import { Component, ElementRef, EventEmitter, Input,  Output,  ViewChild,  ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AutoCompleteOption } from './_models/autoCompleteOption';

@Component({
    selector: 'input-auto-complete', templateUrl: './input-auto-complete.component.html', styleUrls: ['./input-auto-complete.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputAutoCompleteComponent {
    @ViewChild('input') input: ElementRef<HTMLInputElement>;
    @Input() isDisabled: boolean = false;
    @Input() control: FormControl = new FormControl();
    @Input() label: string = '';
    @Input() placeholder: string = 'elemento.generico-input.placeholder-simplified';
    @Input() options: AutoCompleteOption[] = null;
    @Input() isMultiselect: boolean = false;
    @Output() onDeleteText: EventEmitter<null> = new EventEmitter();
    filteredOptions: AutoCompleteOption[];

    filter(): void {
        const filterValue = this.input.nativeElement.value.toLowerCase();

        if (filterValue.length === 0) {
            this.filteredOptions = this.options;
            this.onDeleteText.emit();
            return;
        }

        this.filteredOptions = this.options.filter(o => o.name.toLowerCase().startsWith(filterValue));
    }
}
